@if (tools.size > 0) {
<div class="wrapper" [ngClass]="{'wrapper--transparent': transparencyEnabled}">
    <app-tool-drawing-canvas></app-tool-drawing-canvas>
    <app-tool-settings
        [tools]="tools"
        [(activeTool)]="activeTool"
    ></app-tool-settings>
    <app-tool-instances
        [tools]="tools"
        [(activeTool)]="activeTool"
    ></app-tool-instances>
</div>
}
